import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { BackdropCircular } from 'components';
import { Card, Grid, Icon, Typography} from '@material-ui/core';


export default function Configurations() {
  const {profile, userStoreData} = useSelector((state) => state.user);
  const {loadingStripe} = useSelector((state) => state.stripe);
  const permissions = profile?.config?.permissions || {};
  const storeType = userStoreData?.storeType || null;
  const isRegular = storeType === 'regular';
  const isSkinCeuticals = storeType === 'skinceuticals';
  const isPremiumPlus = storeType === 'premium_plus' || storeType === 'modern_premium_plus';
  const isPremium = storeType === 'premium' || storeType === 'modern_premium';
  const isModern = storeType === 'premium_lite';
  // const isSite = storeType === 'custom';

  return (
    <div className="p-8">
      <Grid container spacing={3} className="text-center">
        {permissions?.settingsHomepage &&
        (isRegular || isPremium || isPremiumPlus || isSkinCeuticals || isModern) &&
        <Grid item xs={12} sm={3} md={2} title="Click here to select your bestsellers, this month’s specials, and new items you want to highlight on your store’s main page">
          <Link to="/configurations/homepage">
            <Card className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
              <Icon className="text-40" color="primary">home</Icon>
              <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Homepage Settings</Typography>
            </Card>
          </Link>
        </Grid>
        }
        {permissions?.settingsAboutUsPage && (isPremium || isPremiumPlus || isModern) &&
        <Grid item xs={12} sm={3} md={2} title="Click here to setup About Us Page">
          <Link to="/configurations/about-us-page">
            <Card className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
              <Icon className="text-40" color="primary">groups</Icon>
              <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">About Us Page</Typography>
            </Card>
          </Link>
        </Grid>
        }
        {permissions?.settingsBeforeAfterGallery &&
        <Grid item xs={12} sm={3} md={2} title="Click here to setup Before/After Gallery Page">
          <Link to="/configurations/before-after-gallery">
            <Card className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
              <Icon className="text-40" color="primary">compare</Icon>
              <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Before/After Gallery</Typography>
            </Card>
          </Link>
        </Grid>
        }
        <Grid item xs={12} sm={3} md={2} title="The Store Contact Information appears in your store footer and in transactional emails associated with your store.">
          <Link to="/configurations/contacts">
            <Card  className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
              <Icon className="text-40" color="primary">info</Icon>
              <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Store Contact Info</Typography>
            </Card>
          </Link>
        </Grid>
        {permissions?.settingsGeneral &&
        <Grid item xs={12} sm={3} md={2} title="Click here to upload your logos">
          <Link to="/configurations/general">
            <Card  className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
              <Icon className="text-40" color="primary">web</Icon>
              <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Store Logos</Typography>
            </Card>
          </Link>
        </Grid>
        }
        {permissions?.settingsSocialMedia &&
        (isRegular || isPremium || isPremiumPlus || isSkinCeuticals || isModern) &&
        <Grid item xs={12} sm={3} md={2} title="Click here to review/add/edit/delete the links to your social media accounts">
          <Link to="/configurations/social-media-links">
            <Card  className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
              <Icon className="text-40" color="primary">facebook</Icon>
              <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Social Media <br /> Links</Typography>
            </Card>
          </Link>
        </Grid>
        }
        {permissions?.settingsTagline && (isRegular || isSkinCeuticals) &&
        <Grid item xs={12} sm={3} md={2} title="Click here to configure a custom tagline/slogan for your store">
          <Link to="/configurations/tagline">
            <Card  className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
              <Icon className="text-40" color="primary">format_color_text</Icon>
              <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Tagline</Typography>
            </Card>
          </Link>
        </Grid>
        }
        {permissions?.settingsColorPalette &&
          (isRegular || isPremium || isPremiumPlus || isSkinCeuticals || isModern) &&
          !userStoreData?.isOldMigrated &&
          <Grid item xs={12} sm={3} md={2}>
            <Link to="/configurations/styles-palette">
              <Card  className="p-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
                <Icon className="text-40" color="primary">color_lens</Icon>
                <Typography variant="h5" color="primary" className="mt-4 max-w-150 min-h-50">Styles Palette</Typography>
              </Card>
            </Link>
          </Grid>
        }
        {isPremium &&
          <Grid item xs={12} sm={3} md={2}>
            <Link to="/configurations/book-now-button">
              <Card  className="p-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
                <Icon className="text-40" color="primary">stars_icon</Icon>
                <Typography variant="h5" color="primary" className="mt-4 max-w-150 min-h-50">Book Now Button</Typography>
              </Card>
            </Link>
          </Grid>
        }
        {isPremium &&
          <Grid item xs={12} sm={3} md={2}>
            <Link to="/configurations/request-appointment-button">
              <Card  className="p-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
                <Icon className="text-40" color="primary">group_add_icon</Icon>
                <Typography variant="h5" color="primary" className="mt-4 max-w-150 min-h-50">Request An Appointment Button</Typography>
              </Card>
            </Link>
          </Grid>
        }
      </Grid>
      <BackdropCircular loading={loadingStripe} />
    </div>
  );
}
